const BranchSummaryReportTypes = {
	/** ***************** FETCH BranchSummary DETAILS START *********************** */
	FETCH_BRANCH_SUMMARY_REPORT_START: 'fetch_Branch_Summary_Report_Start',
	FETCH_BRANCH_SUMMARY_REPORT_SUCCESS: 'fetch_Branch_Summary_Report_Success',
	FETCH_BRANCH_SUMMARY_REPORT_FAILURE: 'fetch_Branch_Summary_Report_Failure',
	FETCH_BRANCH_SUMMARY_REPORT_RESPONSE_RESET_START:
		'fetch_Branch_Summary_ReportResponseResetStart',
	FETCH_BRANCH_SUMMARY_REPORT_RESPONSE_CHANGED: 'fetch_Branch_Summary_ReportResponseResetChanged',
	/** ***************** FETCH BranchSummary DETAILS END *********************** */
};
export default BranchSummaryReportTypes;
